var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5C8.41775 2.5 6.87103 2.96919 5.55544 3.84824C4.23985 4.72729 3.21447 5.97672 2.60897 7.43853C2.00347 8.90034 1.84504 10.5089 2.15372 12.0607C2.4624 13.6126 3.22433 15.038 4.34315 16.1569C5.46197 17.2757 6.88743 18.0376 8.43928 18.3463C9.99113 18.655 11.5997 18.4965 13.0615 17.891C14.5233 17.2855 15.7727 16.2602 16.6518 14.9446C17.5308 13.629 18 12.0822 18 10.5C18 8.37827 17.1571 6.34344 15.6569 4.84315C14.1566 3.34285 12.1217 2.5 10 2.5V2.5ZM10.8 15.3H9.2V13.7H10.8V15.3ZM10.8 12.1H9.2V5.7H10.8V12.1Z",
    fill: "#c3c3c3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarIcon7);
export default __webpack_public_path__ + "static/media/navbar-icon7.2e2a44e39dd1922fa35681df0e774af4.svg";
export { ForwardRef as ReactComponent };